import { Document } from '@contentful/rich-text-types'

export enum DisplayType {
    MODAL = 'Modal',
    TOOLTIP = 'Tooltip'
}

export type DisplayTypes = DisplayType.MODAL | DisplayType.TOOLTIP

export type HelpEntry = {
    title: string
    displayType: DisplayTypes
    content: Document
}

export type AkixiDocumentEntry = {
    title?: string
    subtitle?: string
    content?: Document
}

export type AssetEntry = {
    title: string
    description: string
    file: {
        url: string
        details: {
            image: {
                width: number
                height: number
            }
        }
    }
}

export type HelpEntries = HelpEntry[]

export type HelpEntryMap = {
    [key: string]: HelpEntry
}

export type AssetEntryMap = {
    [key: string]: AssetEntry
}

export type HelpAssets = {
    helpEntries: HelpEntryMap
    assets?: AssetEntryMap
}

export type AkixiDocumentAsset = {
    entry?: AkixiDocumentEntry
    assets?: AssetEntryMap
}

export type ContentfulEntryItem<T extends unknown> = {
    metadata: object
    sys: {
        id: string
    }
    fields: T
}

export type ContentfulEntriesResponse<T extends unknown> = {
    includes: {
        Asset: ContentfulEntryItem<AssetEntry>[]
    }
    total: number
    skip: number
    limit: number
    items: ContentfulEntryItem<T>[]
}
